const precision = 100

export function transformY(el, y, unit = 'px') {
  return (el.style.transform = `translate3d(0, ${Math.round(y * precision) / precision}${unit}, 0)`)
}

export function transformX(el, x, unit = 'px') {
  return (el.style.transform = `translate3d(${Math.round(x * precision) / precision}${unit}, 0, 0)`)
}

export function transformZ(el, z, unit = 'px') {
  return (el.style.transform = `0, 0, translate3d(${Math.round(z * precision) / precision}${unit})`)
}

export function transform(el, x, y, z, unit = 'px') {
  return (el.style.transform = `translate3d(${Math.round(x * precision) / precision}${unit}, ${Math.round(y * precision) / precision}${unit}, ${
    Math.round(z * precision) / precision
  }${unit})`)
}
